module.exports = __webpack_public_path__ + "img/prev-btn.10cef676.svg";